import { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { MiniappSdkDemoInput } from 'app/pages/miniapp-sdk-demo/miniapp-sdk-demo-input';
import { MiniappSdkMethodDemo } from 'app/pages/miniapp-sdk-demo/miniapp-sdk-method-demo';

export const MiniappSdkStorageGetDemo = (): JSX.Element => {
  const intl = useIntl();
  const [storageKey, setStorageKey] = useState('');
  const args = useMemo(() => [storageKey], [storageKey]);

  return (
    <MiniappSdkMethodDemo actionGroup="storage" action="get" eventName="getStorageResponse" args={args}>
      <MiniappSdkDemoInput
        value={storageKey}
        onChange={setStorageKey}
        placeholder={intl.formatMessage({ id: 'sdkDemo.placeholders.storageKey' })}
        dataTestId="storageGetKey"
      />
    </MiniappSdkMethodDemo>
  );
};
